import { LOGIN_SOURCES, } from '../../types/paramsConfig.js';
import { sourceDataActions } from './sourceDataSlice.js';
const referrerMapTable = [
    {
        pattern: 'candidate-login',
        loginSource: LOGIN_SOURCES.OTHER,
        redirectOverride: '/jobs/candidate-login-redirect',
    },
];
const buildFromReferrer = (referrerUrl) => {
    const found = referrerMapTable.find((item) => referrerUrl.match(item.pattern));
    if (found) {
        return {
            loginSource: found.loginSource,
            redirectionUrl: found.redirectOverride || referrerUrl,
        };
    }
    return {
        loginSource: LOGIN_SOURCES.OTHER,
        redirectionUrl: '/',
    };
};
export const initSourceDataByReferrer = (referrerUrl) => async (dispatch) => {
    const sourceData = buildFromReferrer(referrerUrl);
    try {
        dispatch(sourceDataActions.initSourceData(sourceData));
    }
    catch (error) {
        console.error('Error: ', error);
    }
};
export const initSourceDataByCustomEvent = (payload) => async (dispatch) => {
    try {
        const { loginSource, disableCvUpload, redirectionUrl, onLoginSuccess: callbackFunction, isDismissible = true, showRecruiterContinueButton = false, } = payload || {};
        loginSource && dispatch(sourceDataActions.updateLoginSource(loginSource));
        disableCvUpload &&
            dispatch(sourceDataActions.updateRedirectAfterSuccessfulRegistration(disableCvUpload));
        redirectionUrl &&
            dispatch(sourceDataActions.updateRedirectionUrl(redirectionUrl));
        callbackFunction &&
            dispatch(sourceDataActions.updateCallbackFunction(callbackFunction));
        dispatch(sourceDataActions.updateIsDismissible(isDismissible));
        dispatch(sourceDataActions.updateShowRecruiterContinueButton(showRecruiterContinueButton));
    }
    catch (error) {
        console.error('Error:', error);
    }
};
//# sourceMappingURL=thunks.js.map